import setup from './moduleSetup';

export default {
    name: 'vendorHeaderMenuItems',
    before: [],
    after: [],
    setup,
};
